import React from 'react';

// Popover rápido de un turno/evento (nombre, hora, duración, notas + acciones),
// compartido entre Calendario.jsx y PendientesDelDia.jsx.
function TurnoPopover({ cita, x, y, onCerrar, onEditar, onVerFicha, onCancelar, onRenombrar, cancelando }) {
  return (
    <>
      <div className="cal-popover-overlay" onClick={onCerrar} />
      <div className="cal-popover" style={{ left: x, top: y }}>
        <button className="cal-popover-close" onClick={onCerrar}>✕</button>
        <span className="cal-popover-nombre">
          {cita.patient_name || cita.title || 'Evento'}
          {onRenombrar && (
            <button
              type="button"
              className="cal-popover-btn-renombrar"
              onClick={() => onRenombrar(cita)}
              title="Renombrar"
              aria-label="Renombrar"
            >
              ✏️
            </button>
          )}
        </span>
        {cita.time && (
          <div className="cal-popover-hora">
            {cita.time.slice(0, 5)}
            {cita.duration && ` · ${cita.duration} min`}
          </div>
        )}
        {cita.notes && (
          <div className="cal-popover-notas">{cita.notes}</div>
        )}
        <div className="cal-popover-acciones">
          {onEditar && (
            <button className="cal-popover-btn" onClick={() => onEditar(cita)}>
              Editar turno
            </button>
          )}
          {!cita.is_event && onVerFicha && cita.patient && (
            <button className="cal-popover-btn" onClick={() => onVerFicha(cita.patient)}>
              Ver ficha del paciente
            </button>
          )}
          <button
            className="cal-popover-btn cal-popover-btn-danger"
            onClick={() => onCancelar(cita.id)}
            disabled={cancelando}
          >
            {cita.is_event ? 'Eliminar evento' : 'Cancelar turno'}
          </button>
        </div>
      </div>
    </>
  );
}

export default TurnoPopover;
